const CORE_API_BASE = `${process.env.REACT_APP_CORE_API_HOST}`
const BACKOFFICE = 'backoffice'
const AUTH = 'auth'
const PASSWORDS = 'passwords'
const REPRESENTATIVES = 'representatives'
const INSTITUTIONS = 'institutions'
const NOTIFICATIONS = 'notifications'

export const GOALS = 'goals'
export const STUDENTS = 'students'
export const TRAVEL_PACKAGE = 'travel-package'
export const TRAVEL_PACKAGES = `${TRAVEL_PACKAGE}s`

export const LOGIN_ENDPOINT = `${CORE_API_BASE}/${BACKOFFICE}/${AUTH}/login`
export const LOGOUT_ENDPOINT = `${CORE_API_BASE}/${BACKOFFICE}/${AUTH}/logout`
export const FIRST_CHANGE_PASSWORD_ENDPOINT = `${CORE_API_BASE}/${BACKOFFICE}/${AUTH}/${PASSWORDS}/first-change`
export const RECOVER_PASSWORD_ENDPOINT = `${CORE_API_BASE}/${BACKOFFICE}/${AUTH}/${PASSWORDS}/forgot`
export const REFRESH_TOKEN_ENDPOINT = `${CORE_API_BASE}/${BACKOFFICE}/${AUTH}/refresh-token`
export const RESET_PASSWORD_ENDPOINT = `${CORE_API_BASE}/${REPRESENTATIVES}/${PASSWORDS}/reset`

export const GET_INSTITUTIONS_BY_REPRESENTATIVE_ENDPOINT = `${CORE_API_BASE}/${REPRESENTATIVES}/${INSTITUTIONS}`
export const GET_DESTINATIONS_ENDPOINT = `${CORE_API_BASE}/destinations`
export const GET_PACKAGES_ENDPOINT = `${CORE_API_BASE}/${TRAVEL_PACKAGES}`
export const GET_NOTIFICATIONS_ENDPOINT = `${CORE_API_BASE}/${NOTIFICATIONS}`
